import("../../../assets/js/splide.js")
    .then(({ Splide }) => {
        const sliders = document.querySelectorAll(".related-sectors-grid .splide");
        const splideInstances = [];

        function initSplides() {
            sliders.forEach((slider, i) => {
                // If already initialized, destroy first
                if (splideInstances[i]) {
                    splideInstances[i].destroy();
                }
                splideInstances[i] = new Splide(slider, {
                    type: "slide",
                    rewind: true,
                    arrows: true,
                    pagination: true,
                    gap: "1rem",
                    padding: "0",
                    perPage: 1,
                    mediaQuery: "min",
                    breakpoints: {
                        640: {
                            perPage: 2,
                        },
                        1024: {
                            destroy: true
                        },
                    },
                });
                splideInstances[i].mount();
            });
        }

        initSplides();

        window.addEventListener("resize", () => {
            initSplides();
        });
    })
    .catch((err) => {
        console.error(err);
    });